import { ResourceConstants } from "../constants";

export const resources = (state = { resourceLoader: false }, action) => {
  switch (action.type) {
    case ResourceConstants.ENUM_REQUEST:
      return {
        ...state,
      };
    case ResourceConstants.ENUM_SUCCESS:
      return {
        ...state,
        enumData: action.enumData,
      };
    case ResourceConstants.ENUM_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case ResourceConstants.CREATERESOURCEUSER_REQUEST:
      return {
        ...state,
      };
    case ResourceConstants.CREATERESOURCEUSER_SUCCESS:
      return {
        ...state,
        newUser: action.user,
      };
    case ResourceConstants.CREATERESOURCEUSER_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case ResourceConstants.CREATERESOURCE_REQUEST:
      return {
        ...state,
      };
    case ResourceConstants.CREATERESOURCE_SUCCESS:
      return {
        ...state,
        newResource: action.resource,
      };
    case ResourceConstants.CREATERESOURCE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case ResourceConstants.UPDATERESOURCE_REQUEST:
      return {
        ...state,
      };
    case ResourceConstants.UPDATERESOURCE_SUCCESS:
      return {
        ...state,
        newResource: action.resource,
      };
    case ResourceConstants.UPDATERESOURCE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case ResourceConstants.RESOURCESTATUSCHANGE_REQUEST:
      return {
        ...state,
      };
    case ResourceConstants.RESOURCESTATUSCHANGE_SUCCESS:
      return {
        ...state,
      };
    case ResourceConstants.RESOURCESTATUSCHANGE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};
